<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<lcsj-filter :show-search="false" more-text="更多筛选" @search="inputChange()">
			<template #query>
				<el-button size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
				<el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
				
			</template>
			<template #actions><el-button size="small" type="primary" class="el-icon-plus" @click="handleAdd()">新增</el-button></template>
			<el-form-item label="按钮名称：">
					<el-input clearable v-model="formInline.name" size="small" placeholder="请输入按钮名称" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
			</lcsj-filter>
			<!--列表-->
			<STable :columns="columnsData" :data="listData" :loading="loading" :row-key="'keyId'" @get-data="getListData" @row-click="handleRowClick"></STable>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</topTab>
		<!-- 编辑 -->
		<edit ref="edit"></edit>
	</div>
</template>

<script>
import { GetBtnOpLibraryList } from "../../../api/menuApi.js";
import edit from "./edit";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "按钮权限配置"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			expandAll: true,
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 15,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 15,
				name: ""
			},
			listData: [],
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "60",
					isKeep: true
				},
				{
					prop: "name",
					label: "按钮名称"
				},
				{
					prop: "code",
					label: "权限编码"
				}
			]
		};
	},
	// 注册组件
	components: {
		edit
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.getListData();
	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		// 顶部tab页面切换
		changePages(tab) {},

		// 点击新增
		handleAdd() {
			this.$refs.edit.editShow();
		},

		// 单击行数据
		handleRowClick(row) {
			this.$refs.edit.editShow(row);
		},

		// 重置
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.inputChange();
		},

		// 搜索事件
		inputChange() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},

		// 获取列表
		getListData() {
			this.listData = [];
			this.loading = true;
			GetBtnOpLibraryList(this.formInline)
				.then((res) => {
					this.loading = false;
					if (res.code == 1) {
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},

		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		}
	}
};
</script>

<style scoped></style>
